import React from "react";
import { Divider } from "antd";

import "./TotalSummary.css";

const TotalSummary = ({ data }) => {
  return (
    <div className="d-flex justify-content-between total-outer-container">
      <div className="total-summary-container">
        <div className="total-value">{data?.totalExpenditure || 0}</div>
        <div className="total-label">Total Pengeluaran</div>
      </div>
      <Divider className="total-divider" type="vertical" />
      <div className="total-summary-container">
        <div className="total-value">{data?.totalIncome || 0}</div>
        <div className="total-label">Total Pemasukan</div>
      </div>
      <Divider className="total-divider" type="vertical" />
      <div className="total-summary-container">
        <div className="total-value">{data?.totalProfit || 0}</div>
        <div className="total-label">Total Pendapatan</div>
      </div>
    </div>
  );
};

export default TotalSummary;
